<template>
  <div class="sysConfigList">
    <!-- 搜索 -->
    <sirui-search
      v-if="dictList.length > 10"
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'configType'">
              <dict-span dictType="sysConfigType" v-model="scope.row[item.field]"></dict-span>
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/systemManage/sysConfig';
  import DictSpan from '@/components/DictSpan';
  import { mapState } from 'vuex';
  export default {
    name: 'sysConfigList',
    components: {
      SiruiSearch,
      DictSpan,
      SiruiTable,
    },
    computed: {
      searchColumns() {
        return [
          {
            name: '参数名称',
            prop: 'configName',
            type: 'input',
            clearable: true,
          },
          {
            name: '参数键名',
            prop: 'configKey',
            type: 'input',
            clearable: true,
          },
          {
            // 账户属性
            name: '系统配置类型',
            prop: 'configType',
            type: 'select',
            options: this.dictList.find((it) => it.dictType == 'sysConfigType').dictList,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictList: (state) => state.dict.dictList,
      }),
    },
    data() {
      return {
        searchForm: {
          configName: null,
          configKey: null,
          configType: null,
        },
        load: false,
        tableData: [],
        multipleSelection: [],
        menuButtonList: [],
        columnList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'configName',
            title: '配置名称',
            visible: true,
          },
          {
            field: 'configCode',
            title: '配置键名',
            visible: true,
          },
          {
            field: 'configValue',
            title: '配置值',
            visible: true,
          },
          {
            field: 'configType',
            title: '配置类型',
            visible: true,
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      // 搜索
      search() {
        this.getData();
      },
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.searchForm, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_SYSCONFIG_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      chooseClick(value) {
        if (value == 'add' || value == 'edit') {
          let [query, name] = [{}, 'sysConfigAdd'];
          if (value == 'edit') {
            if (this.multipleSelection.length != 1) {
              this.$message({
                showClose: true,
                message: '请选择一条数据进行操作',
                type: 'error',
              });
            }
            [query, name] = [
              {
                type: 'edit',
                id: this.multipleSelection[0].id,
              },
              'sysConfigEdit',
            ];
          }
          let path = {
            path: '/system/' + name,
            name: name,
            meta: {
              keepAlive: true,
            },
            query: query,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (value == 'del') {
          this.handleDel();
        }
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.$message({ showClose: true, type: 'error', message: '您还未选择任何数据!' });
        }
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            this.del(ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        this.$axios.post(API.DELETE_SYSCONFIG, ids).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 列表双击
      dblclickEvent(value) {
        let path = {
          path: '/system/sysConfigEdit',
          name: 'sysConfigEdit',
          meta: {
            keepAlive: false,
          },
          query: {
            type: 'query',
            id: value.row.id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 修改每页条数
      handleSizeChange() {
        this.getData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getData();
      },
      // 表格选择行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
    },
  };
</script>

<style scoped></style>
